import _ from 'lodash';

import {
  exportExcel,
} from '../../../../libs/reports';

const centerStyle = {
  border: true,
  verticalAlignment: 'center',
  horizontalAlignment: 'center',
};

const leftStyle = {
  border: true,
  verticalAlignment: 'center',
  horizontalAlignment: 'left',
};

const exportHandler = ({
  rows,
  totals,
  onSuccess,
}) => {
  exportExcel('Mau_SachSoHoaTheoTaiKhoan', (workbook) => {
    const sheet = workbook.sheet(0);
    let rowIndex = 5;

    _.forEach(rows, (row, index) => {
      sheet.row(rowIndex).height(25);
      sheet.cell(`A${rowIndex}`).value(index + 1).style(centerStyle);
      sheet.cell(`B${rowIndex}`).value(row.email).style(leftStyle);
      sheet.cell(`C${rowIndex}`).value(row.traditional).style(centerStyle);
      sheet.cell(`D${rowIndex}`).value(row.children).style(centerStyle);
      sheet.cell(`E${rowIndex}`).value(row.total).style(centerStyle);
      rowIndex += 1;
    });

    sheet.range(`A${rowIndex}:B${rowIndex}`).merged(true);
    sheet.row(rowIndex).height(25);
    sheet.cell(`A${rowIndex}`).value('Tổng cộng').style(centerStyle);
    sheet.cell(`C${rowIndex}`).value(totals.traditional).style(centerStyle);
    sheet.cell(`D${rowIndex}`).value(totals.children).style(centerStyle);
    sheet.cell(`E${rowIndex}`).value(totals.total).style(centerStyle);
    sheet.range(`A5:E${rowIndex}`).style({
      border: true,
    });
    sheet.range(`A${rowIndex}:E${rowIndex}`).style({
      bold: true,
    });
  }, onSuccess, 'ThongKeSachSoHoaTheoTaiKhoan', true);
};

export default exportHandler;
